module.exports = __webpack_public_path__ + "img/sample09.ab155d18.gif";